var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "anchor",
      staticClass: "section-menu-anchor position-relative",
      class: { "mx-n2": _setup.isMobile },
      style: _setup.anchorStyle,
    },
    [
      _c("div", {
        ref: "sentinel",
        staticClass: "section-menu__sentinel",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "root",
          staticClass: "section-menu bg-gray-0",
          class: { "section-menu--pinned elevation-1": _setup.isPinned },
          style: _setup.pinnedStyle,
          attrs: { "data-qa": "section_menu" },
        },
        [
          _c(
            "div",
            {
              staticClass: "position-relative",
              class: { [_setup.containerClass]: !_setup.isMobile },
            },
            [
              _c("div", {
                staticClass: "section-menu__fog section-menu__fog_left",
                class: { "section-menu__fog_visible": _setup.showLeftFog },
              }),
              _vm._v(" "),
              _c(_setup.CoreSwiper, {
                ref: "swiperRef",
                attrs: {
                  "data-qa": "section_menu_slider",
                  "free-mode": "",
                  "slides-per-view": "auto",
                  "has-pagination": false,
                  "space-between": 0,
                  "initial-slide": _setup.activeTabIndex ?? 0,
                  "placeholder-min-height": 52,
                },
                scopedSlots: _vm._u([
                  {
                    key: "slides",
                    fn: function ({ slideAttrs }) {
                      return _vm._l(_setup.items, function (item, index) {
                        return _c(
                          "div",
                          _vm._b({ key: index }, "div", slideAttrs, false),
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "section-menu__tab text-none text-decoration-none d-inline-flex align-center cursor-pointer gc-2",
                                class: [
                                  _setup.activeTabIndex === index
                                    ? "text-subtitle-1 section-menu__tab--active"
                                    : "text-body-1",
                                  _setup.prevTabIndex !== undefined &&
                                  _setup.activeTabIndex !== undefined &&
                                  _setup.prevTabIndex <= _setup.activeTabIndex
                                    ? "section-menu__tab--left-to-right"
                                    : "section-menu__tab--right-to-left",
                                ],
                                attrs: { "data-qa": "section_menu_item" },
                                on: {
                                  click: function ($event) {
                                    return _setup.handleSlideClick(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text--text",
                                    attrs: {
                                      "data-qa": "section_menu_item_title",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.title) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                item.count != null
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-subtitle-1 text-lpu-branding-color-primary",
                                        attrs: {
                                          "data-qa": "section_menu_item_count",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.count) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "section-menu__fog section-menu__fog_right",
                class: { "section-menu__fog_visible": _setup.showRightFog },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }